export default __webpack_public_path__ + "images/form-hero.261509e9d87fe9d1fb10e60db3891173.jpg";